export default () => {
  require('src/filterpage/autocomplete.js');
  require('src/filterpage/url-params.js');
  require('src/filterpage/therapists.js');
  require('src/filterpage/range-slider.js');
  require('src/filterpage/picker.date.js');
  require('src/filterpage/mobile.js');
};
